var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"textarea input__container"},[_c('span',{staticClass:"input__label"},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_c('textarea',{staticClass:"input__value",attrs:{"type":_vm.type,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"change":function($event){_vm.debounce ? _vm.dChange($event) : _vm.change($event)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }